export enum ReportType {
  REGISTRATION_PARTICIPANT = "REGISTRATION_PARTICIPANT",
  REGISTRATION_ORGANIZATION = "REGISTRATION_ORGANIZATION",
  PROGRAM_ORGANIZATION = "PROGRAM_ORGANIZATION",
  MEETING_PROGRAM_PARTICIPANT = "MEETING_PROGRAM_PARTICIPANT",
  MEETING = "MEETING",
  TABLETALK = "TABLETALK",
  RATE_CARD_DISCOUNT = "RATE_CARD_DISCOUNT",
  TICKET_TRANSFER = "TICKET_TRANSFER",
  TRANSACTION = "TRANSACTION",
  ORGANIZATION_MEETING_AGENDA_SUMMARY_REPORT = "ORGANIZATION_MEETING_AGENDA_SUMMARY_REPORT",
  EVENT_PARTICIPANT = "EVENT_PARTICIPANT",
  LEAD_GENERATION = "LEAD_GENERATION",
  CONTACT_SHARE = "CONTACT_SHARE",
  PROGRAM_PARTICIPANT_MEETING_AGENDA_SUMMARY_REPORT = "PROGRAM_PARTICIPANT_MEETING_AGENDA_SUMMARY_REPORT"
}
